export default __webpack_public_path__ + "b.png";